import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "options", "onChange", "onItemSelect", "separator"];
import React, { forwardRef } from 'react';
import { HeaderNavigationSearchRoot, NavigationItemSearch } from './style';
import { HEADER_NAVIGATION_SEARCH_CLASS_PREFIX, headerNavigationSearchRoot } from './constants';
import { useHeaderNavigationSearchClassName } from './hooks';
import { useTheme } from '../../../styling';
export var HeaderNavigationSearch = forwardRef(function HeaderNavigationSearch(_ref, ref) {
  var className = _ref.className,
      options = _ref.options,
      onChange = _ref.onChange,
      onItemSelect = _ref.onItemSelect,
      separator = _ref.separator,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  var classOverride = useHeaderNavigationSearchClassName(HEADER_NAVIGATION_SEARCH_CLASS_PREFIX, className);
  return React.createElement(NavigationItemSearch, {
    theme: theme,
    className: classOverride.ItemSearch,
    separator: separator
  }, React.createElement(HeaderNavigationSearchRoot, Object.assign({
    "data-testid": headerNavigationSearchRoot
  }, restProps, {
    options: options,
    onChange: onChange,
    onItemSelect: onItemSelect,
    theme: theme,
    className: classOverride.NavigationSearchRoot,
    ref: ref
  })));
});
HeaderNavigationSearch.defaultProps = {
  separator: true
};